import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('help/list', { params });
  },
  async add(params: any) {
    return axios.post('help/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('help/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('help/detail', { params });
  },
  async delete(params: any) {
    return axios.post('help/delete', qs.stringify(params));
  },
  async status(params: any) {
    return axios.post('help/status', qs.stringify(params));
  }
};
